import { render, staticRenderFns } from "./SignedTextView.vue?vue&type=template&id=46b99130&"
import script from "./SignedTextView.vue?vue&type=script&lang=ts&"
export * from "./SignedTextView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports